var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHs3LogoSimple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 105 50",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AFEB3C",
    d: "M105,33.7C104.7,43.4,97.8,50,87,50c-8.1,0-15.2-3.6-20.1-9.3l-0.1-0.1l8-7.7L75,33 c3.7,4.1,7.5,6.2,12.1,6.2c4.1,0,6.6-2,6.8-5.1c0.3-3.9-2.7-6.2-9.5-6.2h-5.9v-8.2l9.1-8.7H72.2h-2.3c-4.8,0-8.7,3.9-8.7,8.7v8.2 c0,12-9.7,21.8-21.7,21.8h-0.2h-11V30.7H11v18.9H0V26.1V0h11v19.7h7.2h10.1V0h11v38.7h0.2c5.9,0,10.7-4.8,10.7-10.8v-8.2 c0-10.6,8.4-19.3,19-19.7v0h35v11l-9.2,8.7C101.8,21.7,105.2,27.9,105,33.7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHs3LogoSimple);
export default __webpack_public_path__ + "static/media/hs3_logo_simple.746777cd601f375b60e82c15db7f2432.svg";
export { ForwardRef as ReactComponent };